import { Query } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { DayInfoState, DayInfoStore } from './day-info.store';
import { DateRange } from '../../models/date-range';
import * as moment from 'moment/moment';
import { ISavedListSettingsQuery } from '../../interfaces/settings/saved-list-settings.query';
import { TableColumn } from '../../models/table-column';
import { getTableColumns } from './table-columns';
import { PersonDateRange } from '../../models/client-models';

@Injectable({
  providedIn: 'root',
})
export class DayInfoQuery
  extends Query<DayInfoState>
  implements ISavedListSettingsQuery
{
  saldo$ = this.select((state) => state.saldo);
  account$ = this.select((state) => state.saldo.accounts);
  selectedDateRange$ = this.select(
    (state) =>
      ({
        start: state?.selectedDateRange?.start,
        end: state?.selectedDateRange?.end,
        range: state?.selectedDateRange?.range,
      }) as DateRange
  );
  dayTableColumns$ = this.select((state) => state.tableColumns);
  visumData$ = this.select((state) => state?.dateVisumInfo);
  dateEditable$ = this.select(
    (state) => state?.dayCheck?.yearOpen && !state?.dayCheck?.insideLockDate
  );
  currentVisum$ = this.select((state) => state?.currentVisum);
  viewState$ = this.select((state) => state?.viewState);

  constructor(protected store: DayInfoStore) {
    super(store);
  }

  getDateRange(personID: number): PersonDateRange {
    return {
      personID,
      startDate: moment(this.getValue()?.selectedDateRange?.start).format(),
      endDate: moment(this.getValue()?.selectedDateRange?.end).format(),
    } as PersonDateRange;
  }

  getCurrentVisum() {
    return this.store.getValue()?.currentVisum;
  }

  filterOptions(): any {
    return null;
  }

  getFilterColumns(): TableColumn[] {
    return [];
  }

  getInitialColumns(): TableColumn[] {
    return getTableColumns();
  }

  getInitialFilter(): any {
    return null;
  }

  getTableColumns(): TableColumn[] {
    return this.store.getValue()?.tableColumns;
  }

  hasFilter(): boolean {
    return false;
  }

  newFilterStructure(): boolean {
    return false;
  }
}
